import { actionTypes } from "../actions/default.action"

const initialState = {
  companies: {
    data: [],
  },
  company: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        companies: {
          ...state.companies,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        companies: {
          ...state.companies,
          data: state.companies.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        company: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
